import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CustomHttp} from '../shared/custom.http';


import 'rxjs/add/operator/toPromise';

import {DPCustomer} from './dp-customer';
import { ApiConstants } from '../shared/api.constants';

@Injectable()
export class DPCustomerService {

    private customerUrl = '/demandportal/customer';  // URL to web api

    constructor(private router: Router, private http: CustomHttp, private apiConstants: ApiConstants) {
    }

    getCustomers() {
        return this.http.get(this.apiConstants.ENDPOINT_HELPDESK_CUSTOMER, {body: ''});
    }

    getCustomer(customer_id: number) {
        return this.http.get(this.apiConstants.getCustomerByIdUrl(customer_id), {body: ''});
    }

    delete(customer: DPCustomer) {
        return this.http.delete(this.apiConstants.getCustomerByIdUrl(customer.customer_id), {body: ''});
    }

    createCustomer(customer: DPCustomer): Promise<DPCustomer> {
        return this.http.post(this.apiConstants.ENDPOINT_HELPDESK_CUSTOMER, JSON.stringify(customer));
    }

    updateCustomer(customer: DPCustomer) {
        return this.http.put(this.apiConstants.getCustomerByIdUrl(customer.customer_id), JSON.stringify(customer));
    }
}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-customer.service.ts